// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__yzWMr","title":"InfoRow_title__35O2m"};